import { TableCell, TextField } from '@mui/material';
import { Control, Controller, FieldName } from 'react-hook-form';

import { IFormInput } from '~/scenes/PeopleModule/components/Tabs/AbsencesTab/components/VacationBalanceData/useVacationBalanceDataForm';

import { useSxStyles } from './useStyles';

export const BalanceSummaryEditCell = (cellProps: {
  control: Control<IFormInput>;
  fieldName: FieldName<IFormInput>;
  cellValue: number;
  editMode: boolean;
}) => {
  const { control, fieldName, cellValue, editMode } = cellProps;

  const sxStyles = useSxStyles();

  return (
    <Controller
      control={control}
      name={fieldName}
      render={({ field }) => {
        return editMode ? (
          <TableCell align={'right'} sx={sxStyles.editCell}>
            <TextField
              {...field}
              margin={'none'}
              size={'small'}
              sx={sxStyles.field}
              fullWidth={true}
            />
          </TableCell>
        ) : (
          <TableCell align={'right'} sx={sxStyles.readCell}>
            {cellValue}
          </TableCell>
        );
      }}
    />
  );
};
